<template>
  <q-bar class="bg-white">
    <div class="col text-center">{{ $t('forgetPassword.title') }}</div>
  </q-bar>
  <q-form ref="form" class="q-ma-md q-gutter-md">
    <q-input
      v-model="form.code"
      class="full-width"
      outlined
      type="text"
      bg-color="white"
      :label="`${$t('generic.text.validationCode')} *`"
      :rules="codeRules"
    />
    <div class="row full-width justify-between">
      <q-btn
        outline
        :label="$t('generic.text.previous')"
        :to="{ name: 'ForgetPassword' }"
      />
      <q-btn outline :label="$t('generic.text.next')" @click="onNext" />
    </div>

    <div class="divider--dark full-width q-my-xl">
      {{ $t('generic.text.or') }}
    </div>

    <q-btn
      flat
      color="primary"
      class="full-width q-my-none"
      :label="$t('generic.text.backToLogin')"
      :to="{ name: 'Login' }"
    />
  </q-form>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      form: {
        code: '',
      },
      codeRules: [
        (v) =>
          !!v ||
          this.$t('generic.error.required', {
            msg: this.$t('generic.text.validationCode'),
          }),
      ],
    };
  },
  methods: {
    ...mapActions({
      checkValidationCode: 'user/checkValidationCode',
    }),

    onNext() {
      this.$refs.form.validate().then((success) => {
        if (!success) return;

        this.checkValidationCode(this.form.code)
          .then(() => {
            this.$notify.create({
              message: this.$t('forgetPassword.verifyCode.success'),
              position: 'top',
              type: 'positive',
            });
            this.$router.push({ name: 'ResetPassword' });
          })
          .catch((err) => {
            console.log(err.response);
            if (err.response.status === 404) {
              this.$notify.create({
                message: this.$t('forgetPassword.verifyCode.notFound'),
                position: 'top',
                type: 'negative',
              });
            } else {
              this.$notify.create({
                message: this.$t('forgetPassword.verifyCode.failed'),
                caption: err.response.data,
                position: 'top',
                type: 'negative',
              });
            }
          });
      });
    },
  },
};
</script>
